import {useContext, useEffect, useState} from "react";
// @ts-ignore
import {APIContext} from "../Globals.tsx";
// @ts-ignore
import {Modal} from "../Modal.tsx";
// @ts-ignore
import {EmailStringsDTO} from "../model/EmailStringsDTO.tsx";
// @ts-ignore
import {EmailStringDTO} from "../model/EmailStringDTO.tsx";
// @ts-ignore
import {SettingsCard} from "./SettingCard.tsx";
import NumberInputWeex from "../elements/NumberInputWeex";

const explainations = {
  low_ticket_warning: {
    name: "Wenig Kontingent Warunung",
    description: "Wenn das Kontingent eines Vertrags zu Ende geht, wird diese Email geschickt. Gilt nur bei einmaligen Kontingent.",
    test: true
  }, email_contact: {
    name: "Kontakt E-Mail", description: "Wird verwendet für zum Beispiel Anfragen für ein Drop-In.", test: false
  }, milestone: {
    name: "Meilenstein E-Mail",
    description: "Wird regelmäßig zum eingestellten Intervall verschickt. {milestone} fügt den Meilenstein in den E-Mail Text ein.",
    test: false
  }, signed_in: {
    name: "Kurs Anmeldung E-Mail",
    description: "Wird verschickt wenn man sich z.B. zu einem Drop-In anmeldet. Variablen: {firstname}, {lastname}, {course}, {date}",
    test: false
  }
}

export default function EmailStrings(){
  const [emailStrings, setEmailStrings] = useState<EmailStringsDTO>();
  const [addNewEmailString, setAddNewEmailString] = useState<boolean>(false);
  const [emailStringInput, setEmailStringInput] = useState<EmailStringDTO>();
  const {getEmailStrings, saveEmailString, testEmailStrings} = useContext(APIContext)

  useEffect(() => {
    getEmailStrings().then((res) => setEmailStrings(res))
  }, []);

  function renderEmailText(string: EmailStringDTO){
    return <SettingsCard onEdit={() => {
      setEmailStringInput(string);
      setAddNewEmailString(true);
    }} onDelete={null}>
      <h4>{explainations[string.name]?.name}</h4>
      <p style={{fontSize: "0.8rem", color: "var(--lightgray)"}}>{explainations[string.name]?.description}</p>
      <label>Text:</label>
      <p style={{whiteSpace: "break-spaces"}}>{string.text}</p>
      {explainations[string.name]?.test &&
        <button onClick={() => testEmailStrings().then((r) => r && window.location.reload())}
                className={"primarybutton"}>Sende eine Test E-Mail an mich</button>}
    </SettingsCard>
  }

  function renderContractInput(){
    return <Modal
      actionP={() => {
        saveEmailString(emailStringInput).then((res) => {
          setEmailStrings({
            strings: emailStrings?.strings.map(str => str.name === res.name ? res : str)
          })
          setEmailStringInput(null)
          setAddNewEmailString(false)
        })
      }}
      actionS={() => setAddNewEmailString(false)}
      buttonS={"Schließen"}
      buttonP={"Speichern"}
      valid={emailStringInput?.text}>
      <label>Text:</label>
      <textarea value={emailStringInput?.text ?? ""} onChange={(e) => setEmailStringInput(old => {
        return {...old, text: e.target.value}
      })} rows={15} cols={80}/>
      {emailStringInput.interval !== null && emailStringInput.interval !== undefined &&
        <label>Intervall:</label>}
      {emailStringInput.interval !== null && emailStringInput.interval !== undefined &&
        <NumberInputWeex onChange={(e) => setEmailStringInput(old => {
          return {...old, interval: e}
        })} value={emailStringInput?.interval} placeholder={50}/>}
    </Modal>
  }

  return (<div style={{position: "relative", width: "100%", height: "100%"}}>
    {addNewEmailString && renderContractInput()}

    <h3>Email Texte</h3>
    <p style={{fontSize: "0.8rem", color: "var(--lightgray)"}}>{"E - Mail Texte können auch HTML enthalten, z.B.: <b>das ist dick</b> oder <a href='https://abc.com'>das ein link zu abc.com</a>"}</p>
    <div id={"course_types"} className={"news-container"}>
      {emailStrings?.strings?.map((string) => renderEmailText(string))}
    </div>
  </div>);
}
